import { fetchSettings, updateSettingValue } from './api';
import Selectors from './selectors';

export const SET_UNIT_OF_MEASURE = 'SET_UNIT_OF_MEASURE';

export const REQUEST_ALL_SETTINGS = 'REQUEST_ALL_SETTINGS';
export const REQUEST_ALL_SETTINGS_ERROR = 'REQUEST_ALL_SETTINGS_ERROR';
export const ADD_ALL_SETTINGS = 'ADD_ALL_SETTINGS';

export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const UPDATE_SETTINGS_ERROR = 'UPDATE_SETTINGS_ERROR';
export const UPDATE_SETTINGS_SUCCESS = 'UPDATE_SETTINGS_SUCCESS';
export const CLEAR_SETTINGS = 'CLEAR_SETTINGS';

export const SET_PENDING_VALUE = 'SET_PENDING_VALUE';

export const UNIT_OF_MEASURE = {
    IMPERIAL: 'IMPERIAL',
    METRIC: 'METRIC'
};

export const DEFAULT_UOM = process.env.REACT_APP_USER_DEFAULT_UNIT_OF_MEASURE_OVERRIDE || "IMPERIAL";
export const DEFAULT_LANGUAGE = process.env.REACT_APP_USER_DEFAULT_LOCALE_OVERRIDE || "EN_US";

//const setUnitOfMeasure = unitOfMeasure => ({ type: SET_UNIT_OF_MEASURE, payload: unitOfMeasure });

// Each individual setting is represented by an object containing a value, optionally containing an error or a pending flag
// {
//   'user.general.unitOfMeasure': { value: 'METRIC', pending: true },
//   'account.facialRecognition.enabled': { value: false, error: 'Failed to update settings.' },
// }

function wrap(settings) {
    if (!settings || typeof settings !== 'object') return settings;

    const result = {};
    for (let key in settings) {
        result[key] = { value: settings[key] };
    }
    if (!result['user.general.unitOfMeasure']) {
        result['user.general.unitOfMeasure'] = { value: DEFAULT_UOM };
    }
    if (!result['user.general.locale']) {
        result['user.general.locale'] = { value: DEFAULT_LANGUAGE };
    }
    return result;
}

const requestAllSettings = () => ({ type: REQUEST_ALL_SETTINGS });

const requestAllSettingsError = error => ({ type: REQUEST_ALL_SETTINGS_ERROR, payload: error });

const addAllSettings = settings => ({ type: ADD_ALL_SETTINGS, payload: wrap(settings) });

const setPendingValue = (key,value) => ({
    type: SET_PENDING_VALUE,
    payload: {
        [key]: {
            value, pending: true
        }
    }
});

export const loadSettings = stage => (dispatch, getState) => {
    if (Selectors.loading(getState())) {
        return Promise.resolve();
    }
    dispatch(requestAllSettings());
    return fetchSettings(stage)
        .then(settings => dispatch(addAllSettings(settings)))
        .catch(err => dispatch(requestAllSettingsError(err)));
};

export const invalidateSettings = () => ({ type: CLEAR_SETTINGS });

export const updateSettings = (stage, settings) => (dispatch, getState) => {
    return Promise.reject(new Error('updateSettings not implemented'));
};

export const changeSetting = (stage, key, value) => (dispatch, getState) => {
    const { pending } = Selectors.getSetting(getState(), key) || {};
    if (pending) {
        return Promise.resolve();
    }
    dispatch(setPendingValue(key, value));
    return updateSettingValue(stage, key, value)
        .then(settings => dispatch(addAllSettings(settings)))
        .catch(err => dispatch(requestAllSettingsError(err)));
};
